import React from 'react';
import CapabilityQuestion from './CapabilityQuestion';
function CapabilityElement({ element }) {
  return <CapabilityQuestion question={element} />;
}

export default CapabilityElement;
